// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f210e256","703":"aebb34cd"}[chunkId] + ".chunk.js";
};